import { render, staticRenderFns } from "./ShowMoreText.vue?vue&type=template&id=8b75fd0a&scoped=true&"
import script from "./ShowMoreText.vue?vue&type=script&lang=js&"
export * from "./ShowMoreText.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreText.vue?vue&type=style&index=0&id=8b75fd0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b75fd0a",
  null
  
)

export default component.exports